<div class="box-novo-compromisso" *ngIf="showModal" (click)="onBackgroundClick($event)">
  <div class="box-formulario" (click)="$event.stopPropagation()">
    <div class="row">
      <div class="col-md-6">
        <h5><i class="fa fa-comment"></i> Feedback</h5>
      </div>
      <div class="col-md-6 text-right" style="padding-top: 5px;">
        <i (click)="fecharModal()" class="fa fa-close"></i>
      </div>
      <hr class="hr-titulo">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <textarea [(ngModel)]="feedback.texto" class="form-control textarea" name="texto" id="texto"
                      placeholder="Digite sua sugestão e/ou feedback"></textarea>
          </div>
        </div>
        <div class="col-md-12 text-center" style="margin-top: 20px;">
          <button class="btn btn-primary col-md-6" (click)="salvarFeedback()">Salvar</button>
        </div>
      </div>
    </div>
  </div>
</div>
